import { BaseRouteService } from 'core/services';

class WoundPatientRouteService extends BaseRouteService {
    constructor() {
        super('woundPatients');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
}

export default WoundPatientRouteService;
